<template>
  <div class="login-container">
    <!-- 背景动画 -->
    <div class="bg-animation">
      <div class="wave"></div>
      <div class="wave"></div>
      <div class="wave"></div>
    </div>
    
    <!-- 登录卡片 -->
    <div class="login-card">
      <div class="logo-container">
        <img :src="logo" alt="Company Logo" class="logo">
      </div>
      
      <h1 class="login-title">Partner Login</h1>
      <p class="login-subtitle">Access your partner dashboard</p>
      
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        class="login-form"
        label-position="top"
      >
        <el-form-item 
          :label="$t('nav.도메인')" 
          prop="domain" 
          v-if="domain_input"
          class="form-item"
        >
          <el-input 
            v-model="form.domain" 
            :placeholder="$t('nav.도메인')"
            prefix-icon="el-icon-link"
            @change="loadCaptcha"
          ></el-input>
        </el-form-item>

        <el-form-item 
          :label="$t('nav.아이디')" 
          prop="username"
          class="form-item"
        >
          <el-input 
            v-model="form.username" 
            :placeholder="$t('nav.아이디')"
            prefix-icon="el-icon-user"
          ></el-input>
        </el-form-item>
        
        <el-form-item 
          :label="$t('nav.비밀번호')" 
          prop="password"
          class="form-item"
        >
          <el-input 
            v-model="form.password" 
            :placeholder="$t('nav.비밀번호')" 
            type="password"
            prefix-icon="el-icon-lock"
            show-password
          ></el-input>
        </el-form-item>
        
        <el-form-item
          v-if="captchaEnabled"
          label="인증코드"
          prop="captcha"
          class="form-item"
        >
          <div class="captcha-row">
            <el-input
              v-model="form.captcha"
              placeholder="Captcha"
              prefix-icon="el-icon-key"
              maxlength="4"
            ></el-input>
            <button
              type="button"
              class="captcha-image"
              :disabled="captchaLoading"
              @click="loadCaptcha"
            >
              <img v-if="captchaImage" :src="captchaImage" alt="captcha">
              <span v-else>{{ captchaLoading ? 'Loading' : 'Refresh' }}</span>
            </button>
          </div>
        </el-form-item>
        
        <el-button 
          type="primary" 
          class="login-button" 
          @click="onSubmit" 
          :loading="loading"
        >
          {{ loading ? '로그인중' : '로그인' }}
        </el-button>
      </el-form>
      
      <!--<div class="login-footer">
        <p>Need help? <a href="#">Contact support</a></p>
      </div>-->
    </div>

    <!-- 两步验证弹窗 -->
    <el-dialog
      :title="$t('newAdd.단계인증')"
      :visible.sync="creatModel"
      class="verify-dialog"
      width="400px"
    >
      <div class="verify-content">
        <p class="verify-description">
          {{ $t('newAdd.더욱안전한계정보호를위해단계인증을진행합니다') }}
        </p>
        
        <el-form 
          ref="verifyForm" 
          :model="verifyForm" 
          v-loading="verifyLoading"
          :rules="rules"
        >
          <el-form-item 
            :label="$t('newAdd.핸드폰번호')" 
            prop="goole"
            class="verify-item"
          >
            <el-input 
              v-model="verifyForm.goole" 
              type="number"
              prefix-icon="el-icon-mobile-phone"
            ></el-input>
          </el-form-item>
          
          <el-form-item 
            :label="$t('newAdd.인증번호')" 
            prop="email"
            class="verify-item"
          >
            <div class="verify-code-input">
              <el-input 
                v-model="verifyForm.email" 
                type="number"
              ></el-input>
              <el-button 
                type="default" 
                @click="getCountdown" 
                :disabled="totalTime < 60"
                class="verify-button"
              >
                {{ content }}
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
      
      <div slot="footer" class="dialog-footer">
        <el-button 
          type="primary" 
          @click="verifySubmit"
          class="verify-submit"
        >
          {{ $t('msg.확인') }}
        </el-button>
      </div>
    </el-dialog>

    <!-- 版本选择弹窗 -->
    <div class="version-modal" v-if="version">
      <div class="version-content">
        <el-button 
          icon="el-icon-close" 
          @click="versionShow" 
          circle 
          class="version-close"
        ></el-button>
        
        <div class="version-buttons">
          <el-button 
            type="primary" 
            @click="versionOld"
            class="version-button"
          >
            Legacy Version
          </el-button>
          <el-button 
            type="default" 
            @click="versionNew"
            class="version-button"
          >
            Current Version
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      version: false,
      screenWidth: 0,
      totalTime: 60,
      content: this.$i18n.t("newAdd.인증받기"),
      logo: '',
      verifyLoading: false,
      domain_input: false,
      loading: false,
      captchaEnabled: false,
      captchaLoading: false,
      captchaImage: '',
      creatModel: false,
      form: {
        username: '',
        password: '',
        captcha: '',
        captchaKey: '',
        domain: ''
      },
      verifyForm: {
        goole: '',
        email: ''
      },
      rules: {
        goole: [
          { required: true, message: this.$i18n.t("newAdd.핸드폰번호를입력하세요"), trigger: 'blur' },
        ],
        email: [
          { required: true, message: this.$i18n.t("newAdd.인증코드를입력하세요"), trigger: 'blur' },
        ],
        username: [
          { required: true, message: this.$i18n.t("newAdd.아이디를입력하세요"), trigger: 'blur' },
        ],
        password: [
          { required: true, message: this.$i18n.t("newAdd.비밀번호를입력하세요"), trigger: 'blur' },
        ],
        domain: [
          { required: true, message: this.$i18n.t("newAdd.도메인을입력하세요"), trigger: 'blur' },
        ],
        captcha: [
          { validator: this.validateCaptcha, trigger: 'blur' },
        ],
      },
    };
  },
  created() {
    this.getScreenSize();
    this.initializeLogin();
  },
  methods: {
    initializeLogin() {
      this.$axios({
        method: 'post',
        url: 'https://flow.bd7080.com/get_domain',
        data: { domain: window.location.host }
      }).then((response) => { 
        if (response.data.code == 200) {
          this.logo = response.data.logo;
          this.form.domain = response.data.msg || '';
          this.domain_input = !response.data.msg;
          this.captchaEnabled = Number(response.data.captcha) === 1;
          if (this.captchaEnabled) {
            this.loadCaptcha();
          }
        } else if (response.data.code == 500) {
          window.location = response.data.msg;
        }
      }).catch((error) => {
        console.log(error);
      });
    },

    validateCaptcha(rule, value, callback) {
      if (this.captchaEnabled && !value) {
        callback(new Error('Captcha required'));
        return;
      }

      callback();
    },

    formatCaptchaImage(img) {
      if (!img) return '';
      return img.indexOf('data:') === 0 ? img : 'data:image/png;base64,' + img;
    },

    loadCaptcha() {
      if (!this.captchaEnabled || !this.form.domain) return;

      this.captchaLoading = true;
      this.$axios({
        method: 'get',
        url: 'https://' + this.form.domain + '/api/captcha'
      }).then((response) => {
        const data = response.data || {};
        this.form.captcha = '';
        this.form.captchaKey = data.key || '';
        this.captchaImage = this.formatCaptchaImage(data.img || '');
        this.captchaLoading = false;
      }).catch((error) => {
        console.log(error);
        this.form.captchaKey = '';
        this.captchaImage = '';
        this.$message.error('Captcha load failed');
        this.captchaLoading = false;
      });
    },
    
    getScreenSize() {
      this.screenWidth = document.documentElement.clientWidth;
    },
    
    versionOld() {
      // 旧版本逻辑
    },
    
    versionNew() {
      // 新版本逻辑
    },
    
    versionShow() {
      this.version = !this.version;
    },
    
    getCountdown() {
      let clock = window.setInterval(() => {
        this.content = this.totalTime + 's' + this.$t('newAdd.후재전송');
        this.totalTime--;
        if (this.totalTime < 0) {
          this.totalTime = 60;
          this.content = this.$t('newAdd.인증번호재전송');
          window.clearInterval(clock);
        }
      }, 1000);
    },
    
    verifySubmit() {
      this.$refs.verifyForm.validate((valid) => {
        if (!valid) return;
        // 验证提交逻辑
      });
    },
    
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        this.loading = true;

        if (this.form.domain.indexOf("http") > -1) {
          this.$message({
            type: 'error',
            message: this.$i18n.t("newAdd.http삭제해주세요"),
          });
          this.loading = false;
          return;
        }

        this.$axios({
          method: 'post',
          url: 'https://' + this.form.domain + '/agentapilogin',
          data: {
            username: this.form.username,
            password: this.form.password,
            domain: this.form.domain,
            captcha: this.form.captcha,
            captcha_key: this.form.captchaKey,
            captcha_required: this.captchaEnabled ? 1 : 0,
          }
        }).then((response) => { 
          this.loading = false;
          
          if (response.data.code == 500) {
            this.$message.error(response.data.msg);
            if (this.captchaEnabled) {
              this.loadCaptcha();
            }
          } else if (response.data.code == 100) {
            this.creatModel = true;
          } else {
            this.handleLoginSuccess(response.data);
          }
        }).catch((error) => {
          console.log(error);
          this.$message.error(error);
          if (this.captchaEnabled) {
            this.loadCaptcha();
          }
          this.loading = false;
        });
      });
    },
    
    handleLoginSuccess(responseData) {
      window.sessionStorage.setItem('user', responseData.data.access_token);
      window.sessionStorage.setItem('userid', this.form.username);
      window.sessionStorage.setItem('site', responseData.site + '');
      window.sessionStorage.setItem('domain', 'https://' + this.form.domain);
      window.sessionStorage.setItem('sitetype', responseData.sitetype);
      window.sessionStorage.setItem('level', responseData.level);
      window.sessionStorage.setItem('almoney', responseData.almoney);
      window.sessionStorage.setItem('power', responseData.power);
      window.sessionStorage.setItem('simp', responseData.simp);
      window.sessionStorage.setItem('rosing', responseData.rosing);  
      window.sessionStorage.setItem('admin_id', responseData.admin_id);
      window.sessionStorage.setItem('new', responseData.new);
      window.sessionStorage.setItem('off', responseData.off);
      window.sessionStorage.setItem('new_almsys', responseData.new_almsys);
      window.sessionStorage.setItem('money_inout', responseData.money_inout);
      window.sessionStorage.setItem('sid', responseData.sid);

      localStorage.setItem('navActive', JSON.stringify({
        top: '0',
        left: 'dashboard_index'
      }));
      
      this.$message({
        type: 'success',
        message: this.$i18n.t("msg.성공적로그인"),
      });
      
      this.$router.push({ name: 'dashboard_index', params: { rand: Math.random() }});
    }
  }
}
</script>

<style scoped>
.login-container {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  overflow: hidden;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.bg-animation {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.bg-animation .wave {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100px;
  background: url('data:image/svg+xml;utf8,<svg viewBox="0 0 1200 120" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none"><path d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z" fill="rgba(255,255,255,0.2)" opacity=".25"/></svg>');
  background-size: 1200px 100px;
  animation: wave 15s linear infinite;
}

.bg-animation .wave:nth-child(2) {
  bottom: 10px;
  opacity: 0.5;
  animation-delay: -5s;
  animation-duration: 20s;
}

.bg-animation .wave:nth-child(3) {
  bottom: 15px;
  opacity: 0.2;
  animation-delay: -2s;
  animation-duration: 25s;
}

@keyframes wave {
  0% { background-position-x: 0; }
  100% { background-position-x: 1200px; }
}

.login-card {
  position: relative;
  width: 100%;
  max-width: 420px;
  padding: 40px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 15px 35px rgba(50, 50, 93, 0.1), 0 5px 15px rgba(0, 0, 0, 0.07);
  z-index: 10;
  transition: all 0.3s ease;
}

.login-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 18px 40px rgba(50, 50, 93, 0.15), 0 8px 20px rgba(0, 0, 0, 0.1);
}

.logo-container {
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
}

.logo-container .logo {
  max-width: 120px;
  max-height: 60px;
  object-fit: contain;
}

.login-title {
  font-size: 24px;
  font-weight: 600;
  color: #2d3748;
  text-align: center;
  margin-bottom: 8px;
}

.login-subtitle {
  font-size: 14px;
  color: #718096;
  text-align: center;
  margin-bottom: 30px;
}

.login-form .form-item {
  margin-bottom: 20px;
}

.login-form .form-item .el-form-item__label {
  font-weight: 500;
  color: #4a5568;
  padding-bottom: 6px;
}

.login-form .form-item .el-input__inner {
  height: 44px;
  border-radius: 8px;
  padding-left: 40px;
  transition: all 0.3s;
}

.login-form .form-item .el-input__inner:focus {
  border-color: #4299e1;
  box-shadow: 0 0 0 2px rgba(66, 153, 225, 0.2);
}

.login-form .form-item .el-input__prefix {
  left: 10px;
  color: #a0aec0;
}

.captcha-row {
  display: grid;
  grid-template-columns: 1fr 150px;
  gap: 10px;
  width: 100%;
}

.captcha-image {
  height: 44px;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  background: #fff;
  color: #718096;
  cursor: pointer;
  overflow: hidden;
  padding: 0;
}

.captcha-image:disabled {
  cursor: default;
  opacity: 0.7;
}

.captcha-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.login-button {
  width: 100%;
  height: 44px;
  border-radius: 8px;
  background: linear-gradient(135deg, #4299e1 0%, #3182ce 100%);
  border: none;
  font-weight: 500;
  font-size: 16px;
  letter-spacing: 0.5px;
  transition: all 0.3s;
  margin-top: 10px;
}

.login-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(66, 153, 225, 0.3);
}

.login-button:active {
  transform: translateY(0);
}

.login-footer {
  margin-top: 20px;
  text-align: center;
  font-size: 13px;
  color: #718096;
}

.login-footer a {
  color: #4299e1;
  text-decoration: none;
  font-weight: 500;
}

.login-footer a:hover {
  text-decoration: underline;
}

/* 验证弹窗样式 */
.verify-dialog .el-dialog {
  border-radius: 12px;
  overflow: hidden;
}

.verify-dialog .el-dialog__header {
  background: linear-gradient(135deg, #4299e1 0%, #3182ce 100%);
  padding: 15px 20px;
}

.verify-dialog .el-dialog__title {
  color: white;
  font-weight: 500;
}

.verify-dialog .el-dialog__headerbtn {
  top: 15px;
}

.verify-dialog .el-dialog__close {
  color: white;
}

.verify-content {
  padding: 20px;
}

.verify-description {
  color: #718096;
  font-size: 14px;
  margin-bottom: 20px;
  line-height: 1.5;
}

.verify-item {
  margin-bottom: 20px;
}

.verify-item .el-form-item__label {
  font-weight: 500;
  color: #4a5568;
  padding-bottom: 6px;
}

.verify-code-input {
  display: flex;
  gap: 10px;
}

.verify-code-input .el-input__inner {
  height: 40px;
}

.verify-button {
  width: 130px;
  white-space: nowrap;
}

.verify-submit {
  width: 100%;
  height: 44px;
  border-radius: 8px;
  background: linear-gradient(135deg, #4299e1 0%, #3182ce 100%);
  border: none;
  font-weight: 500;
}

/* 版本选择弹窗 */
.version-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.version-content {
  position: relative;
  width: 100%;
  max-width: 500px;
  background: white;
  border-radius: 16px;
  padding: 40px;
  text-align: center;
}

.version-close {
  position: absolute;
  top: 15px;
  right: 15px;
  font-size: 18px;
}

.version-buttons {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 30px;
}

.version-button {
  width: 100%;
  height: 60px;
  font-size: 18px;
  border-radius: 8px;
  transition: all 0.3s;
}

.version-button:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

@media (max-width: 768px) {
  .login-card {
    padding: 30px 20px;
    margin: 0 20px;
  }
  
  .version-content {
    padding: 30px 20px;
    margin: 0 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue